<template>
  <MainProductsListBlockMobile
    :content="content"
    @selected-section="handlerEmit"
  />
</template>
<script>
const MainProductsListBlockMobile = () =>
  import(
    /* webpackChunkName: "MainProductsListBlockMobile" */
    '~/components/Mobile/Main/MainProductsListBlockMobile.vue'
  )
export default {
  name: 'LazyProductsListBlockMobile',
  components: {
    MainProductsListBlockMobile,
  },
  props: {
    content: {
      type: Object,
    },
  },
  methods: {
    handlerEmit(id) {
      this.$emit('selected-section', id)
    },
  },
}
</script>
